import {groupBy} from "lodash"
import {entries} from "@irati/utils/object"
import {ContentCardTrigger} from "./ContentCard"

/**
 * Deduple all content card triggers of the same time, keeping only the latest, all others will be dismissed
 *
 * At time of writing this makes sense for all cards but there may be a future
 * scenario where there may be multiple cards of the same time but for
 * different reasons
 */
export function dedupeTriggers(triggers: ContentCardTrigger[], dismiss: (cards: string[]) => void): ContentCardTrigger[] {
  const grouped = groupBy(triggers, (t: ContentCardTrigger) => t.extras.trigger.triggerId)

  return entries(grouped).flatMap(([, ts]) => {
    // cards are already sorted newest first
    const [latest, ...rest] = ts
    dismiss(rest.map((t) => t.id))
    return latest ? [latest] : []
  })
}
